import React, { useCallback, useEffect, useReducer, useState } from "react";
import styles from "./Giftcards.module.scss";

import { Button } from "components/Buttons/Buttons";
import {
  Badge,
  Dropdown,
  Menu,
  Modal,
  Select,
  Space,
  Table,
  Tag,
  Typography,
} from "antd";

import useSettingsHeader from "hooks/useSettingsHeader";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";
import { MoreOutlined } from "@ant-design/icons";
import usePortal from "hooks/usePortal";
import SearchAndFilterColumns from "components/SearchAndFilterColumns/SearchAndFilterColumns";
import moment from "moment";
import ChangeEmailModal from "./components/ChangeEmailModal";
import {
  getFilteredGiftcards,
  redeemGiftCard,
  resendGiftcardInvitation,
  updateGiftCard,
} from "services/giftCards.service";
import ChangeSendDateModal from "./components/ChangeSendDateModal";
// import GiftCardModalWithCustomerDropdown from "./components/GiftCardModalWithCustomerDropdown";

const { Title, Text, Link } = Typography;

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_SIZE = 10;

const DEFAULT_SORT_BY = "createdOn";
const DEFAULT_SORT_ASCEND = false;

const reducer = (state, action) => {
  switch (action.type) {
    case "SET":
      return action.data;
    case "ADD":
      return [...state, action.data];
    case "UPDATE":
      return state.map((data) => {
        if (data.categoryId === action.data.categoryId) return action.data;
        return data;
      });
    case "DELETE":
      return state.filter((data) => {
        if (data.categoryId === action.data.categoryId) return false;
        return true;
      });
    default:
      return state;
  }
};

export default function Giftcards() {
  //states start
  const [showAddEditModal, setShowAddEditModal] = useState();
  const [data, localDispatch] = useReducer(reducer, []);

  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [redeemFilter, setRedeemFilter] = useState("all"); // all, active, inactive
  const [searchText, setSearchText] = useState("");
  const [showChangeEmailModal, setShowChangeEmailModal] = useState();
  const [showChangeSendDateModal, setShowChangeSendDateModal] = useState();

  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [page, setPage] = useState(DEFAULT_PAGE);
  const [sorter, setSorter] = useState({
    column: DEFAULT_SORT_BY,
    ascend: DEFAULT_SORT_ASCEND,
  });
  //states end

  // non-data hooks start
  const dispatch = useDispatch();
  // non-data hooks end

  useEffect(() => {
    console.log("sorter useffect: ", sorter);
    loadData();
  }, [redeemFilter, searchText, sorter, pageSize, page]);

  const loadData = useCallback(() => {
    const sortColumn = sorter.column;
    dispatch(
      getFilteredGiftcards({
        isRedeemed:
          redeemFilter === "all"
            ? undefined
            : redeemFilter === "redeemed"
            ? true
            : false,
        searchKeyword: searchText,
        orderBy: sorter.column
          ? String(sorter.column[0]).toUpperCase() +
            String(sorter.column).slice(1)
          : undefined,
        sortByAscending: sorter.ascend,
        pageSize: pageSize,
        skip: (page - 1) * pageSize,
      })
    ).then((res) => {
      console.log("res", res);
      if (res?.status === "success") {
        localDispatch({ type: "SET", data: res.data ?? {} });
      }
    });
  }, [redeemFilter, searchText, sorter, pageSize, page]);

  const settingHeaderContent = useSettingsHeader(
    <></>
    // <Button
    //   rounded={true}
    //   onClick={() => {
    //     setShowAddEditModal(true);
    //   }}
    // >
    //   Send Giftcard
    // </Button>
  );

  const columns = [
    {
      title: "Sender",
      fixed: "left",
      children: [
        {
          title: "Name",
          dataIndex: "senderName",
          width: 140,
          sorter: true,
        },
        {
          title: "Email",
          dataIndex: "senderEmail",
          width: 150,
          sorter: true,
        },
        {
          width: 80,
          title: "Guest?",
          dataIndex: "wasSenderGuest",
          render: (wasSenderGuest) => {
            return (
              <Tag color={wasSenderGuest ? "green" : "red"}>
                {wasSenderGuest ? "Guest" : "Non Guest"}
              </Tag>
            );
          },
          sorter: true,
        },
      ],
    },
    {
      title: "Receiver",
      children: [
        {
          title: "Name",
          width: 140,
          key: "recipientFirstName",
          dataIndex: "recipientFirstName",
          render: (col, item) => {
            return item?.recipientFirstName + " " + item?.recipientLastName;
          },
          sorter: true,
        },
        {
          title: "Email",
          dataIndex: "recipientEmail",
          width: 150,
          sorter: true,
        },
        {
          title: "Guest?",
          width: 100,
          dataIndex: "recipientCustomerId",
          render: (recipientCustomerId) => {
            return (
              <Tag color={!!recipientCustomerId ? "green" : "red"}>
                {!!recipientCustomerId ? "Guest" : "Non Guest"}
              </Tag>
            );
          },
          sorter: true,
        },
      ],
      // render: (data) => {
      //   return (
      //     <div>
      //       <span>{data?.receiverName}</span>&nbsp;
      //       <Tag color={data?.isReceiverGuest ? "green" : "red"}>
      //         {data?.isReceiverGuest ? "Guest" : "Non Guest"}
      //       </Tag>
      //       <br />
      //       <span>{data?.receiverEmail}</span>
      //     </div>
      //   );
      // },
    },

    {
      title: "Gift Card",
      key: "cardName",
      dataIndex: "programName",
      render: (programName, item) => {
        return <p style={{width: 150}}>{item.programName ?? `$${item.giftCardPrice}`}</p>;
      },
      width: 250,
    },
    {
      title: "Amount",
      dataIndex: "CreditsPurchased",
      key: "CreditsPurchased",
      width: 140,
      render: (creditsPurchased, item) => {
        return `$${item.giftCardPrice}`;
      },
      sorter: true,
    },
    {
      title: "Date Purchased",
      width: 140,
      dataIndex: "createdOn",
      render: (createdOn) => {
        return <p style={{width: 140}}>{moment(createdOn).format("MMM DD YYYY")}</p>;
      },
      sorter: true,
    },
    {
      title: "Date Sent",
      width: 140,
      dataIndex: "scheduledSendDate",
      render: (scheduledSendDate) => {
        return <p style={{width: 120}}>{moment(scheduledSendDate).format("MMM DD YYYY")}</p>;
      },
      sorter: true,
    },
    {
      title: "Redeemed?",
      width: 50,
      dataIndex: "isRedeemed",
      render: (isRedeemed) => {
        return <>{isRedeemed ? "Yes" : "No"}</>;
      },
      sorter: true,
    },

    {
      title: "",
      key: "action",
      align: "right",
      width: 80,
      render: (data) => {
        return (
          <Dropdown
            overlay={
              <Menu style={{ borderRadius: 6, border: "2px solid #CDD5D8 " }}>
                <Menu.Item
                  disabled={data?.isRedeemed}
                  onClick={() => Modal.confirm(redeemGC(data))}
                  key="redeem"
                >
                  Redeem
                </Menu.Item>
                <Menu.Item
                  disabled={data?.isRedeemed}
                  onClick={() => Modal.confirm(resendEmailConfirmation(data))}
                  key="resend"
                >
                  Resend Email
                </Menu.Item>
                <Menu.Item
                  disabled={data?.isRedeemed}
                  onClick={() => {
                    setShowChangeEmailModal(data);
                  }}
                  key="change"
                >
                  Change Email
                </Menu.Item>
                <Menu.Item
                  disabled={data?.isRedeemed}
                  onClick={() => {
                    setShowChangeSendDateModal(data);
                  }}
                  key="change"
                >
                  Change Send Date
                </Menu.Item>
              </Menu>
            }
            trigger={["click"]}
            getPopupContainer={(triggerNode) => triggerNode?.parentNode}
          >
            <MoreOutlined style={{ fontSize: 18 }} />
          </Dropdown>
        );
      },
    },
  ];

  // functions start
  const handleAdd = (values) => {
    // dispatch(createCategory(values)).then((result) => {
    //   if (result?.status === "success") {
    //     setShowAddEditModal();
    //     loadData();
    //     // loadData();
    //   }
    // });
  };
  const handleRedeem = (id, values) => {
    dispatch(redeemGiftCard(id)).then((result) => {
      if (result?.status === "success") {
        loadData();
      }
    });
  };
  const handleDelete = (id) => {
    // dispatch(deleteCategory(id)).then((result) => {
    //   if (result?.status === "success") {
    //     loadData();
    //   }
    // });
  };
  const handleResendInvitation = (id) => {
    dispatch(resendGiftcardInvitation(id)).then((result) => {
      if (result?.status === "success") {
        loadData();
      }
    });
  };
  const deleteConfirmation = (id) => ({
    title: "Inactivate Category",
    content: <>Are you sure that you want to inactivate the category?</>,
    centered: true,
    maskClosable: true,
    onOk: (close) => {
      handleDelete(id);
      close();
    },
  });

  const redeemGC = (item) => ({
    title: "Redeem Giftcard?",
    content: <>Are you sure that you want to redeem the giftcard?</>,
    centered: true,
    maskClosable: true,
    onOk: (close) => {
      handleRedeem(item.giftCardId);
      close();
    },
  });

  const resendEmailConfirmation = (data) => ({
    title: "Resend Email?",
    content: <>Are you sure that you want to resend the email?</>,
    centered: true,
    maskClosable: true,
    onOk: (close) => {
      handleResendInvitation(data.giftCardId);
      close();
    },
  });

  const checkActiveFilter = (item) => {
    if (redeemFilter === "all") return true;
    else if (redeemFilter === "active" && item?.isActive) return true;
    else if (redeemFilter === "inactive" && !item?.isActive) return true;
    return false;
  };
  // functions end

  const searchAndFiltersContent = usePortal(
    "#settingHeader .settingsHeaderLeftSideAddon",
    <Space>
      <SearchAndFilterColumns
        columns={columns}
        hiddenColumns={hiddenColumns}
        debouceTimeout={1000}
        cancelDebounce={true}
        setHiddenColumns={(columnTitles) => {
          setHiddenColumns(columnTitles);
        }}
        searchText={searchText}
        setSearchText={(text) => {
          setPage(DEFAULT_PAGE);
          setPageSize(DEFAULT_PAGE_SIZE);
          setSearchText(text);
        }}
      />
      <Select
        style={{ width: 120 }}
        value={redeemFilter}
        onChange={(value) => {
          setRedeemFilter(value);
        }}
        options={[
          {
            value: "all",
            label: "All",
          },
          {
            value: "redeemed",
            label: "Redeemed",
          },
          {
            value: "notRedeemed",
            label: "Not Redeemed",
          },
        ]}
      />
    </Space>
  );

  return (
    <div>
      {settingHeaderContent}
      {searchAndFiltersContent}
      <Table
        page={page}
        rowKey={(data) => data.categoryId}
        tableLayout="auto"
        locale={{ emptyText: "No Data" }}
        dataSource={data?.items}
        columns={columns.filter((column) => {
          if (!hiddenColumns.includes(column.title)) return true;
          return false;
        })}
        onChange={(pagination, filters, sorter) => {
          console.log("sorter", sorter);
          setPage(pagination.current);
          setPageSize(pagination.pageSize);
          setSorter({
            column:
              sorter?.column?.dataIndex === undefined
                ? DEFAULT_SORT_BY
                : sorter.field,
            ascend:
              sorter?.column?.dataIndex === undefined
                ? DEFAULT_SORT_ASCEND
                : sorter.order === "ascend",
          });
        }}
        pagination={{
          current: page,
          pageSize: pageSize,
          defaultPageSize: DEFAULT_PAGE_SIZE,
          showSizeChanger: true,
          pageSizeOptions: [15, 25, 50, 100, 250],
          total: data?.totalRecords,
        }}
        scroll={{
          x: true,
        }}
        // scroll={{ y: "calc(100vh - 80px - 96px - 60px - 100px)", x: true }}
      />
      <ChangeEmailModal
        visible={showChangeEmailModal}
        onClose={() => setShowChangeEmailModal(false)}
        onSubmit={(email) => {
          console.log(email);
          dispatch(
            updateGiftCard(showChangeEmailModal.giftCardId, {
              recipientEmail: email,
              recipientFirstName: showChangeEmailModal.recipientFirstName,
              recipientLastName: showChangeEmailModal.recipientLastName,
              scheduledSendDate: showChangeEmailModal.scheduledSendDate,
            })
          )
            .then(() => {
              loadData();
            })
            .finally(() => {
              setShowChangeEmailModal(false);
            });
        }}
      />

      <ChangeSendDateModal
        visible={showChangeSendDateModal}
        onClose={() => setShowChangeSendDateModal(false)}
        onSubmit={(sendDate) => {
          console.log(sendDate);
          dispatch(
            updateGiftCard(showChangeSendDateModal.giftCardId, {
              recipientEmail: showChangeSendDateModal.recipientEmail,
              recipientFirstName: showChangeSendDateModal.recipientFirstName,
              recipientLastName: showChangeSendDateModal.recipientLastName,
              scheduledSendDate: sendDate,
            })
          )
            .then(() => {
              loadData();
            })
            .finally(() => {
              setShowChangeSendDateModal();
            });
        }}
      />
    </div>
  );
}
